module.exports = __webpack_public_path__ + "img/ssms.300e5cec.png";